<template>
  <div class='TaskList'>
    <div class="searchForm">
      <div class="from">
        <span>状态：</span>
        <el-radio-group v-model="search.status"
                        size="medium"
                        @change="changeState">
          <el-radio-button :label="null">全部</el-radio-button>
          <el-radio-button label="1">成功</el-radio-button>
          <el-radio-button label="0">进行中</el-radio-button>
        </el-radio-group>
      </div>

      <!-- <div class="searchBtn">
        <el-button size="medium"
                   type="primary"
                   @click="getItemList">查询</el-button>
        <el-button size="medium"
                   @click="searchResetForm">重置</el-button>
      </div> -->
    </div>

    <Table :TableParam="Table">
      <template v-slot:handle="row">

        <el-link type="primary"
                 @click="()=>downloadItem(row.item)"
                 v-if="!row.item.type && row.item.state.value">下载</el-link>
      </template>
      <template v-slot:Paging>
        <Paging @change="getItemList"
                :pager="pager" />
      </template>
    </Table>
  </div>
</template>

<script>
// 这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
// 例如：import 《组件名称》 from '《组件路径》';
import Table from '@/components/Table'
import Paging from '@/components/Paging'
import { onDownload } from '@/utils'
export default {
  // import引入的组件需要注入到对象中才能使用
  components: {
    Table,
    Paging
  },
  data () {
    // 这里存放数据
    return {
      pager: { // 翻页
        page: 1,
        rows: 10,
        count: 0
      },

      search: {
        status: null
      },

      Table: { // 表格
        handle: true,
        data: [],
        column: [
          { prop: 'taskName', label: '任务名称' },
          { prop: 'startTime', label: '开始时间' },
          { prop: 'duration', label: '时长' },
          { prop: 'stateText', label: '状态' }
        ]
      }
    }
  },
  // 监听属性 类似于data概念
  computed: {},
  // 监控data中的数据变化
  watch: {},
  // 方法集合
  methods: {
    changeState () {
      this.getItemList()
    },
    getItemList () {
      const { pager, search, Table } = this
      const params = {
        pageNum: pager.page,
        pageSize: pager.rows,
        state: search.status
      }
      this.$http.getTaskPagination(params)
        .then((res) => {
          if (res.status === 200) {
            pager.count = res.data.total
            Table.data = res.data.list.map((item) => ({
              ...item,
              stateText: item.state.text
            }))
          }
        })
    },
    downloadItem (row) {
      const params = {
        id: row.id
      }
      this.$http.downloadTaskFile(params)
        .then((res) => {
          const { headers, data } = res
          if (res.status === 200) {
            onDownload(headers, data)
          }
        })
    },

    searchResetForm () {
      const { search } = this
      search.status = null
    }
  },
  // 生命周期 - 创建完成（可以访问当前this实例）
  created () {
    this.getItemList()
  },
  // 生命周期 - 挂载完成（可以访问DOM元素）
  mounted () {

  },
  beforeCreate () { }, // 生命周期 - 创建之前
  beforeMount () { }, // 生命周期 - 挂载之前
  beforeUpdate () { }, // 生命周期 - 更新之前
  updated () { }, // 生命周期 - 更新之后
  beforeDestroy () { }, // 生命周期 - 销毁之前
  destroyed () { }, // 生命周期 - 销毁完成
  activated () { } // 如果页面有keep-alive缓存功能，这个函数会触发
}
</script>
<style lang='scss' scoped>
//@import url(); 引入公共css类
.TaskList {
  .searchForm {
    padding: 35px 50px 35px;
    background-color: #fff;
    margin: 20px;
    border-radius: 10px;
    display: flex;
    justify-content: space-between;
    span {
      color: #555;
    }
  }
}
</style>
